import BaseModel from './BaseModel';
export default class RedirectLink extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.fromLink = data.fromLink || undefined;
        this.toLink = data.toLink || undefined;
        this.isActive = data.isActive || undefined;
        this.createdDate = data.createdDate || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            fromLink: this.fromLink,
            toLink: this.toLink,
            isActive: this.isActive
        });
        return result;
    }

}
